/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface PaymentSourceRequest {

    /**
     * The identifier of the card at the payment gateway
     */
    card_id?: string;

    /**
     * The brand of the card
     */
    brand?: string;

    /**
     * The last four digits of the card number
     */
    last4?: string;

    /**
     * The expiration month of the card
     */
    exp_month?: number;

    /**
     * The expiration year of the card
     */
    exp_year?: number;

    /**
     * The status of the most recent subscription
     */
    status?: string;

    /**
     * The tokenization method. Can be 'apple_pay' for Apple Pay or null for direct credit card
     */
    tokenization_method?: string;

}

@Model('PaymentSource')
export class ApiPaymentSource extends BaseModel implements PaymentSourceRequest {

    /**
     * The identifier of the card at the payment gateway
     */
    
    
    card_id: string;

    /**
     * The brand of the card
     */
    
    
    brand: string;

    /**
     * The last four digits of the card number
     */
    
    
    last4: string;

    /**
     * The expiration month of the card
     */
    
    
    exp_month: number;

    /**
     * The expiration year of the card
     */
    
    
    exp_year: number;

    /**
     * The status of the most recent subscription
     */
    
    
    status: string;

    /**
     * The tokenization method. Can be 'apple_pay' for Apple Pay or null for direct credit card
     */
    
    
    tokenization_method: string;

}
